// extracted by mini-css-extract-plugin
module.exports = {"queryBrowser":"QueryBrowser_queryBrowser__2m6OP","noFavorites":"QueryBrowser_noFavorites__1rav9","favorite":"QueryBrowser_favorite__25JEp"};